// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://nzbrwnqbsdtxyaifmvcn.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im56YnJ3bnFic2R0eHlhaWZtdmNuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDY4MTc0NzYsImV4cCI6MjA2MjM5MzQ3Nn0.l8iumMZA9Vn93CHUqjkxQVBknHxT6QyGALk5HS8HsEA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);